(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aelys-magnetique-ads"] && !Shopify.designMode) return;
  try {
    
if(!window.aelysAdsBound){window.aelysAdsBound=true;
function adsInit(root){root.querySelectorAll('.aelys-ads').forEach(section=>{if(section.dataset.bound)return;section.dataset.bound='true';const form=section.querySelector('form');const select=form.querySelector('[name=id]');const quantity=form.querySelector('[name=quantity]');const submit=form.querySelector('[data-ads-submit]');const sticky=section.querySelector('[data-ads-sticky]');const sync=()=>{const cents=Number(select.selectedOptions[0]?.dataset.price||0)*Math.max(1,Number(quantity.value)||1);const value=new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(cents/100);const price=form.querySelector('[data-ads-price]');if(price)price.textContent=value;section.querySelector('[data-ads-sticky-price]').textContent=value;sticky.disabled=submit.disabled;};form.addEventListener('change',sync);form.addEventListener('input',sync);section.querySelectorAll('[data-ads-step]').forEach(button=>button.addEventListener('click',()=>{quantity.value=Math.max(1,(Number(quantity.value)||1)+Number(button.dataset.adsStep));sync();}));sticky.addEventListener('click',()=>{if(!submit.disabled)form.requestSubmit(submit);});form.addEventListener('submit',async event=>{event.preventDefault();submit.disabled=true;sync();const error=form.querySelector('[data-ads-error]');error.hidden=true;const root=window.Shopify?.routes?.root||'/';try{const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});if(!response.ok){const result=await response.json();throw new Error(result.description||result.message);}window.location.assign(root+'cart');}catch(failure){submit.disabled=false;sync();error.textContent=failure.message||'Impossible d’ajouter cette pince. Réessaie.';error.hidden=false;}});sync();});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>adsInit(document));else adsInit(document);document.addEventListener('shopify:section:load',event=>adsInit(event.target));}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aelys-mega-menu"] && !Shopify.designMode) return;
  try {
    
  const megaRoot=document.querySelector('[data-aelys-mega]');if(megaRoot){const panels=[...megaRoot.querySelectorAll('[data-menu]')];const closePanels=()=>{panels.forEach(panel=>panel.classList.remove('is-open'));document.body.classList.remove('aelys-mega-open')};document.querySelectorAll('.menu-list__link').forEach(link=>{const panel=panels.find(item=>item.dataset.menu===link.textContent.trim().toLowerCase());if(panel){link.addEventListener('mouseenter',()=>{closePanels();panel.classList.add('is-open');document.body.classList.add('aelys-mega-open')});link.addEventListener('focus',()=>{closePanels();panel.classList.add('is-open');document.body.classList.add('aelys-mega-open')})}});megaRoot.addEventListener('mouseleave',closePanels);document.querySelector('header')?.addEventListener('mouseleave',event=>{if(!event.relatedTarget?.closest?.('[data-aelys-mega]'))closePanels()})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aelys-product"] && !Shopify.designMode) return;
  try {
    
  if (!window.aelysProductThumbnailBound) {
    window.aelysProductThumbnailBound = true;
    const aelysBundleRows = bundle => Array.from(bundle.querySelectorAll('[data-aelys-bundle-color]'));
    const aelysBundleTarget = bundle => Number(bundle.querySelector('input[name="aelys_bundle_choice"]:checked')?.value || 1);
    const aelysBundleFormat = cents => new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    function aelysBundleRefresh(bundle) {
      const rows = aelysBundleRows(bundle);
      const target = aelysBundleTarget(bundle);
      const count = rows.reduce((sum, row) => sum + Number(row.querySelector('[data-aelys-bundle-count]').value), 0);
      bundle.querySelector('[data-aelys-bundle-progress]').textContent = count + ' / ' + target;
      rows.forEach(row => {
        const quantity = Number(row.querySelector('[data-aelys-bundle-count]').value);
        const checkbox = row.querySelector('[data-aelys-bundle-color-check]');
        checkbox.checked = quantity > 0;
        checkbox.disabled = Number(row.dataset.max) === 0 || (count >= target && quantity === 0);
        row.classList.toggle('is-selected', quantity > 0);
        row.querySelector('[data-aelys-bundle-minus]').disabled = quantity === 0;
        row.querySelector('[data-aelys-bundle-plus]').disabled = count >= target || quantity >= Number(row.dataset.max);
      });
      const extras = Array.from(bundle.querySelectorAll('[data-aelys-bundle-extra]:checked'));
      const extraPrice = extras.reduce((sum, checkbox) => sum + Number(checkbox.dataset.price), 0);
      const offerPrice = Number(bundle.querySelector('input[name="aelys_bundle_choice"]:checked')?.dataset.price || 1000);
      bundle.closest('form').querySelector('[data-aelys-bundle-total]').textContent = aelysBundleFormat(offerPrice + extraPrice);
      bundle.closest('form').querySelector('button[type="submit"]').disabled = count !== target;
      bundle.querySelector('[data-aelys-bundle-error]').hidden = true;
    }
    function aelysBundlePrefill(bundle) {
      const rows = aelysBundleRows(bundle);
      const target = aelysBundleTarget(bundle);
      const colors = bundle.querySelector('.aelys-product__bundle-colors');
      colors.hidden = target === 1;
      bundle.querySelector('[data-aelys-bundle-colors-title]').textContent = 'Choisis les couleurs de tes ' + target + ' pinces';
      rows.forEach(row => { row.querySelector('[data-aelys-bundle-count]').value = 0; });
      if (target === 1) {
        const selected = rows.find(row => row.hasAttribute('data-current') && Number(row.dataset.max) > 0);
        if (selected) selected.querySelector('[data-aelys-bundle-count]').value = 1;
      }
      aelysBundleRefresh(bundle);
    }
    function aelysBundleInit(root) {
      root.querySelectorAll('[data-aelys-bundle]').forEach(bundle => aelysBundlePrefill(bundle));
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => aelysBundleInit(document));
    else aelysBundleInit(document);
    document.addEventListener('shopify:section:load', event => aelysBundleInit(event.target));
    document.addEventListener('change', function (event) {
      const bundle = event.target.closest('[data-aelys-bundle]');
      if (!bundle) return;
      if (event.target.matches('input[name="aelys_bundle_choice"]')) aelysBundlePrefill(bundle);
      else if (event.target.matches('[data-aelys-bundle-color-check]')) {
        const row = event.target.closest('[data-aelys-bundle-color]');
        row.querySelector('[data-aelys-bundle-count]').value = event.target.checked ? 1 : 0;
        aelysBundleRefresh(bundle);
      }
      else if (event.target.matches('[data-aelys-bundle-extra]')) aelysBundleRefresh(bundle);
    });
    document.addEventListener('click', function (event) {
      const control = event.target.closest('[data-aelys-bundle-plus], [data-aelys-bundle-minus]');
      if (!control) return;
      const row = control.closest('[data-aelys-bundle-color]');
      const output = row.querySelector('[data-aelys-bundle-count]');
      const current = Number(output.value);
      output.value = current + (control.hasAttribute('data-aelys-bundle-plus') ? 1 : -1);
      aelysBundleRefresh(control.closest('[data-aelys-bundle]'));
    });
    document.addEventListener('submit', async function (event) {
      const form = event.target;
      const bundle = form.querySelector('[data-aelys-bundle]');
      if (!bundle) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const target = aelysBundleTarget(bundle);
      const items = aelysBundleRows(bundle).map(row => ({
        id: Number(row.dataset.variantId),
        quantity: Number(row.querySelector('[data-aelys-bundle-count]').value)
      })).filter(item => item.quantity > 0);
      if (items.reduce((sum, item) => sum + item.quantity, 0) !== target) {
        aelysBundleRefresh(bundle);
        return;
      }
      bundle.querySelectorAll('[data-aelys-bundle-extra]:checked').forEach(checkbox => {
        items.push({ id: Number(checkbox.dataset.variantId), quantity: 1 });
      });
      const button = form.querySelector('button[type="submit"]');
      button.disabled = true;
      const error = bundle.querySelector('[data-aelys-bundle-error]');
      error.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const result = await response.json();
          throw new Error(result.description || result.message || 'Une couleur n’est plus disponible.');
        }
        window.location.assign(root + 'cart');
      } catch (failure) {
        aelysBundleRefresh(bundle);
        error.textContent = failure.message || 'Impossible d’ajouter ce pack au panier. Réessaie.';
        error.hidden = false;
      }
    }, true);
    document.addEventListener('click', function (event) {
      const thumbnail = event.target.closest('.aelys-product__thumbnail');
      if (!thumbnail) return;
      const gallery = thumbnail.closest('.aelys-product__gallery');
      const track = gallery?.querySelector('.aelys-product__media-track');
      const panel = track?.children[Number(thumbnail.dataset.mediaIndex)];
      if (!panel) return;
      track.scrollTo({ left: panel.offsetLeft, behavior: 'smooth' });
      gallery.querySelectorAll('.aelys-product__thumbnail').forEach(button => {
        const active = button === thumbnail;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    });
    document.addEventListener('scroll', function (event) {
      const track = event.target;
      if (!track.classList?.contains('aelys-product__media-track') || track._aelysFrame) return;
      track._aelysFrame = requestAnimationFrame(() => {
        track._aelysFrame = null;
        const panels = Array.from(track.children);
        const index = panels.reduce((best, panel, i) =>
          Math.abs(panel.offsetLeft - track.scrollLeft) < Math.abs(panels[best].offsetLeft - track.scrollLeft) ? i : best, 0);
        track.parentElement.querySelectorAll('.aelys-product__thumbnail').forEach((button, i) => {
          button.classList.toggle('is-active', i === index);
          button.setAttribute('aria-pressed', i === index ? 'true' : 'false');
        });
        panels.forEach((panel, i) => {
          if (i !== index) panel.querySelectorAll('video').forEach(video => video.pause());
        });
      });
    }, true);
  }

  if (!window.aelysStickyCartBound) {
    window.aelysStickyCartBound = true;
    function initAelysStickyCart(root) {
      root.querySelectorAll('[data-aelys-sticky-cart]').forEach(sticky => {
        if (sticky.dataset.bound) return;
        const section = sticky.closest('.aelys-product');
        const form = section?.querySelector('.aelys-product__form');
        const submit = form?.querySelector('button[type="submit"]');
        if (!form || !submit) return;
        sticky.dataset.bound = 'true';
        const sync = () => {
          const bundlePrice = form.querySelector('[data-aelys-bundle-total]');
          let price;
          if (bundlePrice) price = bundlePrice.textContent;
          else {
            const select = form.querySelector('select[name="id"]');
            const unitPrice = Number(select?.selectedOptions[0]?.dataset.price || sticky.dataset.basePrice);
            const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));
            const extraPrice = Array.from(form.querySelectorAll('[data-aelys-product-extra]:checked')).reduce((sum, input) => sum + Number(input.dataset.price), 0);
            price = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: sticky.dataset.currency || 'EUR' }).format((unitPrice * quantity + extraPrice) / 100);
          }
          const priceNode = sticky.querySelector('[data-aelys-sticky-price]');
          if (priceNode.textContent !== price) priceNode.textContent = price;
          sticky.disabled = submit.disabled;
        };
        form.addEventListener('change', sync);
        form.addEventListener('input', sync);
        new MutationObserver(sync).observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        sticky.addEventListener('click', () => {
          if (!submit.disabled) form.requestSubmit(submit);
        });
        sync();
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAelysStickyCart(document));
    else initAelysStickyCart(document);
    document.addEventListener('shopify:section:load', event => initAelysStickyCart(event.target));
  }

  if (!window.aelysProductExtrasBound) {
    window.aelysProductExtrasBound = true;
    document.addEventListener('submit', async event => {
      const form = event.target;
      const extras = form.querySelector('[data-aelys-product-extras]');
      const checked = Array.from(form.querySelectorAll('[data-aelys-product-extra]:checked'));
      if (!extras || !checked.length) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('button[type="submit"]');
      const error = extras.querySelector('[data-aelys-product-extras-error]');
      const data = new FormData(form);
      const items = [{id: Number(data.get('id')), quantity: Math.max(1, Number(data.get('quantity') || 1))}];
      checked.forEach(input => items.push({id: Number(input.dataset.variantId), quantity: 1}));
      button.disabled = true;
      error.hidden = true;
      const root = window.Shopify?.routes?.root || '/';
      try {
        const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items})});
        if (!response.ok) {const result = await response.json(); throw new Error(result.description || result.message);}
        window.location.assign(root + 'cart');
      } catch (failure) {
        button.disabled = false;
        error.textContent = failure.message || 'Impossible d’ajouter ces pinces. Réessaie.';
        error.hidden = false;
      }
    }, true);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
